import { __cReviewService } from '@/services/client/__c.review.service'
import { ReviewSheetParams } from '@/types/collection'
import { useQuery } from '@tanstack/react-query'

type UseReviewParams = {
  page?: number
  limit?: number
  filter?: string
  sort?: string
  keywords?: string
}

export const useReview = (productId: string, params: UseReviewParams = {}) => {
  const { page = 1, limit = 10, filter, keywords } = params

  // Xử lý các params filter
  const queryParams: Record<string, string> = {
    page: page.toString(),
    limit: limit.toString(),
  }

  if (filter) {
    const filterParams = filter.split(',')

    filterParams.forEach((param) => {
      const [key, value] = param.split(':')
      if (key && value) {
        queryParams[key] = value
      }
    })
  }

  if (keywords) {
    queryParams.keywords = keywords
  }

  return useQuery({
    queryKey: [
      'reviews',
      productId,
      page,
      limit,
      filter,
      keywords,
      queryParams,
    ],
    queryFn: () => __cReviewService.getReviews(productId, queryParams),
    enabled: !!productId,
  })
}

export const useReviewBySheetId = <T>(params: ReviewSheetParams) => {
  return useQuery<T>({
    queryKey: ['review-by-sheet-id', params],
    queryFn: () => __cReviewService.getReviewBySheetId<T>(params),
    enabled: !!params,
  })
}
